import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, spotMove } from "./Motion";
import { fileUrl } from "../../lib/api";

export const ProductCard = ({ p, catSlug, i = 0 }) => (
  <Reveal delay={(i % 3) * 0.07} className="h-full">
    <Link
      to={`/products/${catSlug}/${p.slug}`}
      onMouseMove={spotMove}
      data-testid={`product-item-card-${p.slug}`}
      className="spot group flex h-full flex-col border border-slate-200 bg-white transition-[border-color,box-shadow] duration-300 hover:border-[#0a6cff] hover:shadow-[0_24px_60px_-30px_rgba(10,108,255,.55)]"
    >
      <div className="clip-corner relative aspect-[4/3] overflow-hidden bg-[#07090e]">
        <img src={fileUrl(p.images?.[0])} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-[1.07]" />
        <span className="font-mono-x absolute left-4 top-4 bg-[#07090e]/80 px-2 py-1 text-[10px] uppercase tracking-widest text-sky-300 backdrop-blur">
          ARI-{String(i + 1).padStart(3, "0")}
        </span>
      </div>
      <div className="flex flex-1 items-end justify-between gap-4 p-6">
        <div>
          <h3 className="font-display text-2xl font-extrabold uppercase leading-none text-slate-950">{p.name}</h3>
          <p className="mt-2 text-sm text-slate-600">{p.short}</p>
        </div>
        <ArrowUpRight className="h-5 w-5 shrink-0 text-slate-400 transition-[color,transform] duration-300 group-hover:rotate-45 group-hover:text-[#0a6cff]" />
      </div>
    </Link>
  </Reveal>
);
